import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgStool = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16.375 11.1667C17.038 11.1667 17.6739 11.43 18.1428 11.8989C18.6116 12.3677 18.875 13.0036 18.875 13.6667C18.875 14.3297 18.6116 14.9656 18.1428 15.4344C17.6739 15.9033 17.038 16.1667 16.375 16.1667H18.875C19.538 16.1667 20.1739 16.43 20.6428 16.8989C21.1116 17.3677 21.375 18.0036 21.375 18.6667C21.375 19.3297 21.1116 19.9656 20.6428 20.4344C20.1739 20.9033 19.538 21.1667 18.875 21.1667H5.125C4.46196 21.1667 3.82607 20.9033 3.35723 20.4344C2.88839 19.9656 2.625 19.3297 2.625 18.6667C2.625 18.0036 2.88839 17.3677 3.35723 16.8989C3.82607 16.43 4.46196 16.1667 5.125 16.1667H7.625C6.96196 16.1667 6.32607 15.9033 5.85723 15.4344C5.38839 14.9656 5.125 14.3297 5.125 13.6667C5.125 13.0036 5.38839 12.3677 5.85723 11.8989C6.32607 11.43 6.96196 11.1667 7.625 11.1667H10.125C9.46196 11.1667 8.82607 10.9033 8.35723 10.4344C7.88839 9.96558 7.625 9.32969 7.625 8.66665C7.625 8.00361 7.88839 7.36773 8.35723 6.89889C8.82607 6.43005 9.46196 6.16665 10.125 6.16665C10.9298 6.16695 11.7133 5.90834 12.3598 5.42903C13.0063 4.94972 13.4814 4.27514 13.715 3.50499C13.747 3.40102 13.8055 3.3072 13.8848 3.23279C13.9642 3.15837 14.0615 3.10595 14.1673 3.0807C14.2731 3.05545 14.3837 3.05825 14.4881 3.08882C14.5924 3.11938 14.687 3.17666 14.7625 3.25499C15.7736 4.24351 16.5398 5.45458 17 6.79165C17.5525 8.74999 16.7017 11.1667 13.875 11.1667H16.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgStool.displayName = 'SvgStool';
export default SvgStool;
